import { Injectable } from '@angular/core';
import { ActionResponse, ActionTypeValues } from 'common_library';
import { HttpIoService } from '../communication/http-io.service';

/**
 * Unico punto di accesso HTTP alle action.
 *
 * Esisteva in due copie (app.component per i deep link, cdc-auth per il rientro
 * dal 3DS) e le due erano già derivate: una chiamava `actions/execute` in POST,
 * l'altra in GET. Su un flusso che registra un metodo di pagamento la deriva non
 * è un dettaglio di stile. Il routing verso la UI resta dei chiamanti — qui c'è
 * solo il trasporto, che deve essere identico per tutti.
 */
@Injectable({ providedIn: 'root' })
export class ActionExecutorService {
  constructor(private readonly HIO: HttpIoService) { }

  async getType(actionUid: string): Promise<ActionTypeValues> {
    const rv = await this.HIO.get<{ type: ActionTypeValues }>(`actions/get-type/${actionUid}`);
    return rv?.type;
  }

  /**
   * Esegue l'action. POST: la GET è deprecata lato backend (veniva innescata
   * anche dai prefetch dei client email). Idempotente lato server — un secondo
   * tentativo su un'action già eseguita risponde `err`, non riesegue.
   */
  async execute(actionUid: string): Promise<ActionResponse> {
    return await this.HIO.post<ActionResponse, {}>(`actions/execute/${actionUid}`, {});
  }
}
